var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('AdCardTitle',{attrs:{"inline":""}},[_vm._v(_vm._s(_vm.$t('questionnaire-response')))]),(false)?_c('div',{staticClass:"px-5 pb-5"},[_vm._v(" "+_vm._s(JSON.stringify(_vm.questionnaireActive))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }